import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "send-24px--sprite",
  "use": "send-24px--sprite-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"send-24px--sprite\"><path d=\"M0 0h24v24H0z\" fill=\"none\" /><path d=\"M2.01 21L23 12 2.01 3 2 10l15 2-15 2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol